export const WORLD = "WORLD",
  GET_BY_NAME = "GET_BY_NAME",
  GET_BY_ID = "GET_BY_ID",
  RE_RENDER_COUNTRIES = "RE_RENDER_COUNTRIES",
  ORDER = "ORDER",
  CLEAR = "CLEAR",
  CLEAR_WORLD = "CLEAR_WORLD",
  ADD = "ADD",
  SHOW_HIDE = "SHOW_HIDE",
  SWITCH_PAGED = "SWITCH_PAGED",
  CONTINENT_FILTER = "CONTINENT_FILTER",
  ACTIVITY_FILTER = "ACTIVITY_FILTER";
